import React from 'react';
import {
  Button as GlobalButton,
  ButtonProps as GlobalButtonProps,
} from 'components/form-elements';

export const Button: React.FC<GlobalButtonProps> = GlobalButton;
